import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ClickOutside from "../ClickOutside";
import { IoSettingsSharp, IoLogOut } from "react-icons/io5";
import { IoIosArrowDown, IoMdSettings, IoMdPerson } from "react-icons/io";
import { MdLogout } from "react-icons/md";
import Model from "../../common/Model";

const DropdownUser = ({ userName }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isLogoutModelOpen, setIsLogoutModelOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogoutClick = () => {
    setDropdownOpen(false);
    setIsLogoutModelOpen(true);
  };

  const confirmLogout = () => {
    localStorage.clear();
    setIsLogoutModelOpen(false);
    navigate("/signin", { replace: true });
    window.location.reload();
  };

  return (
    <ClickOutside onClick={() => setDropdownOpen(false)} className="relative">
      <div className="flex items-center gap-1">
        <button
          onClick={() => setDropdownOpen(!dropdownOpen)}
          className="flex items-center gap-3 px-3 py-1.5 rounded-xl hover:bg-slate-50 transition-all duration-300 group"
        >
          <div className="w-9 h-9 bg-slate-100 rounded-full flex items-center justify-center text-slate-500 group-hover:bg-primary group-hover:text-white transition-all duration-300">
            <IoMdPerson className="text-xl" />
          </div>
          <div className="hidden lg:flex flex-col text-left">
            <span className="text-[13px] font-bold text-slate-700 leading-none mb-0.5">
              {userName || "Guest"}
            </span>
          </div>
          <IoIosArrowDown className={`text-slate-400 transition-transform duration-300 ${dropdownOpen ? "rotate-180" : ""}`} />
        </button>
      </div>

      {dropdownOpen && (
        <div
          className="absolute right-0 mt-3 w-64 bg-white rounded-2xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.15)] border border-slate-100 overflow-hidden z-99999 animate-in fade-in slide-in-from-top-2 duration-300"
        >
          {/* Menu Header */}
          <div className="px-5 py-4 bg-slate-50/50 border-b border-slate-50">
            <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest leading-none mb-1">User Account</p>
            <p className="text-[14px] font-bold text-slate-800 truncate">{userName || "Guest Account"}</p>
          </div>

          <div className="p-2">
            <Link
              to="/settings/user-master"
              className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-slate-600 hover:bg-primary/5 hover:text-primary transition-all duration-200 group"
              onClick={() => setDropdownOpen(false)}
            >
              <div className="w-8 h-8 rounded-lg bg-slate-50 flex items-center justify-center group-hover:bg-primary/10">
                <IoSettingsSharp className="text-[16px]" />
              </div>
              <span className="text-[13px] font-bold">Account Settings</span>
            </Link>
          </div>

          <div className="p-2 border-t border-slate-50 bg-slate-50/30">
            <button
              onClick={handleLogoutClick}
              className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-slate-600 hover:bg-red-50 hover:text-red-600 transition-all duration-200 group"
            >
              <div className="w-8 h-8 rounded-lg bg-white flex items-center justify-center shadow-sm group-hover:bg-red-100/50">
                <IoLogOut className="text-[18px]" />
              </div>
              <span className="text-[13px] font-bold">Log Out</span>
            </button>
          </div>
        </div>
      )}

      <Model
        isOpen={isLogoutModelOpen}
        onClose={() => setIsLogoutModelOpen(false)}
        maxWidth="max-w-md"
      >
        <div className="p-10 text-center">
          <div className="w-20 h-20 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-6 border-4 border-white shadow-xl">
            <MdLogout className="w-10 h-10" />
          </div>
          <h3 className="text-2xl font-black text-slate-800 mb-2 tracking-tight">Ready to Leave?</h3>
          <p className="text-slate-500 mb-10 text-sm font-medium leading-relaxed">
            Are you sure you want to log out? <br />
            You'll need to sign back in to access your dashboard.
          </p>
          <div className="flex items-center gap-4">
            <button
              className="flex-1 py-4 px-6 rounded-2xl font-bold text-slate-600 bg-slate-100 hover:bg-slate-200 transition-all active:scale-95"
              onClick={() => setIsLogoutModelOpen(false)}
            >
              Wait, No
            </button>
            <button
              className="flex-1 py-4 px-6 rounded-2xl font-bold text-white bg-red-500 hover:bg-red-600 shadow-lg shadow-red-200 transition-all active:scale-95"
              onClick={confirmLogout}
            >
              Yes, Log Out
            </button>
          </div>
        </div>
      </Model>
    </ClickOutside>
  );
};

export default DropdownUser;
